import { render, staticRenderFns } from "./AppConfirmPopup.vue?vue&type=template&id=98813e5a"
import script from "./AppConfirmPopup.vue?vue&type=script&lang=ts"
export * from "./AppConfirmPopup.vue?vue&type=script&lang=ts"
import style0 from "./AppConfirmPopup.vue?vue&type=style&index=0&id=98813e5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports